import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "../axiosInstance";
import Cookies from "js-cookie";

export interface ApiCallConfig {
  method: "get" | "post" | "put" | "delete" | "patch";
  url: string;
  data?: any;
  params?: Record<string, any>;
  headers?: Record<string, string>;
  // e.g. "blob" for binary file downloads
  responseType?: AxiosRequestConfig["responseType"];
}

export interface ApiResponse {
  status:boolean;
  message:string;
  data?:any;
  error?: any;
  statusCode?: number;
}

const makeApiCall = async (config: ApiCallConfig): Promise<any> => {
  const accessToken = Cookies.get("access-token");
  try {
    const axiosConfig: AxiosRequestConfig = {
      method: config.method,
      url: config.url,
      data: config.data,
      params: config.params,
      // headers: accessToken ? { Authorization: `${accessToken}` } : {},
      headers: {
        ...(accessToken ? { Authorization: `${accessToken}` } : {}),
        ...(config.headers || {}), // ✅ no more error
      },
      ...(config.responseType ? { responseType: config.responseType } : {}),
    };

    const response: AxiosResponse<any> = await axiosInstance(axiosConfig);
    return response.data;
  } catch (error: any) {
    // Auth outcomes (refresh, retry, session-expired redirect) are owned by
    // the axiosInstance interceptor; by the time an error lands here it is a
    // plain business failure. NOTE: swallowed intentionally — call sites
    // truthiness-check the result rather than try/catch.
    console.log("Error intercepted in makeApiCall:", error);
    return error;
  }
};

export default makeApiCall;
